import axios from '../helpers/api';
import helper from '../helpers/custom/index';
import db from './pouchDb';
import _ from 'lodash';
import store from '@/state/store';
import { v4 as uuidv4 } from 'uuid';

export const salesService = {
    getNatureOfBusiness,
};
async function getNatureOfBusiness() {
    try {
        const res = await axios(`/api/sales/nature-business`);
        return res.data;
    } catch (error) {
        return error;
    }
}